import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

const tableExitVirtualSelectAllModeMutator: (tableView: TableView) => void = mutatorAction(
    'tableExitVirtualSelectAllMode',
    function tableExitVirtualSelectAllMode(tableView: TableView): void {
        tableView.isInVirtualSelectAllMode = false;
        tableView.virtualSelectAllExclusionList = [];
        tableView.selectAllModeTimeStamp = null;
    }
);
export default tableExitVirtualSelectAllModeMutator;
